import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5 4h14q.425 0 .713.288Q20 4.577 20 5a.97.97 0 0 1-.288.713A.96.96 0 0 1 19 6H5a.97.97 0 0 1-.713-.288A.96.96 0 0 1 4 5q0-.425.288-.713A.96.96 0 0 1 5 4m0 16a.97.97 0 0 1-.713-.288A.96.96 0 0 1 4 19v-5h-.175a.96.96 0 0 1-.775-.363.94.94 0 0 1-.2-.837l1-5a1 1 0 0 1 .35-.575A.96.96 0 0 1 4.825 7h14.35a.96.96 0 0 1 .625.225q.275.225.35.575l1 5a.94.94 0 0 1-.2.837.96.96 0 0 1-.775.363H20v5a.97.97 0 0 1-.288.713A.96.96 0 0 1 19 20a.97.97 0 0 1-.713-.288A.96.96 0 0 1 18 19v-5h-4v5a.97.97 0 0 1-.288.713A.96.96 0 0 1 13 20zm1-2h6v-4H6zm-.95-6h13.9l-.6-3H5.65z"
    }, null, -1)
  ]))]))
}
export default { render: render }